function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AddButton } from './AddButton';
import { Button } from './Button';

/**
 * Renders the add button configured for the current market via window.MARKET_CONSTANTS.ADD_BUTTON_TYPE.
 * 'standard' -> AddButton (primary), anything else -> link style button with an add icon.
 */
export function MarketAddButton(_ref) {
  let {
    text,
    ...props
  } = _ref;
  const {
    t
  } = useTranslation();
  if (window.MARKET_CONSTANTS?.ADD_BUTTON_TYPE === 'standard') {
    return /*#__PURE__*/React.createElement(AddButton, _extends({
      variant: "primary",
      text: text
    }, props));
  }
  return /*#__PURE__*/React.createElement(Button, _extends({
    variant: "link",
    icon: "add"
  }, props), text ? t(text) : t('add'));
}